import { CardContent } from '@mui/material';
import { MinimalCard } from 'components/styled';

import { Typography, Chip, Spacer, Centered } from './styles';

function Skills() {
  return (
    <MinimalCard $hoverEffect={false} sx={{ mb: 6 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Skills
        </Typography>

        <Spacer mb={4} />

        <Centered>
          <Chip size="small" sx={{ mr: 1, mb: 1 }} label="HTML" color="secondary" />
          <Chip size="small" sx={{ mr: 1, mb: 1 }} label="JavaScript" />
          <Chip size="small" sx={{ mr: 1, mb: 1 }} label="Sass" />
          <Chip size="small" sx={{ mr: 1, mb: 1 }} label="React" />
          <Chip size="small" sx={{ mr: 1, mb: 1 }} label="Redux" />
          <Chip size="small" sx={{ mr: 1, mb: 1 }} label="Next.js" />
          <Chip size="small" sx={{ mr: 1, mb: 1 }} label="Material UI" />
          <Chip size="small" sx={{ mr: 1, mb: 1 }} label="UI" />
          <Chip size="small" sx={{ mr: 1, mb: 1 }} label="UX" />
        </Centered>
      </CardContent>
    </MinimalCard>
  );
}

export default Skills;
